module.exports = __webpack_public_path__ + "img/prompt.ed09aed2.png";